export default "__VITE_ASSET__854b316e__"